/**
 * デバイスグループの選択肢（for-select）API Contract。
 * dresscode-backend #8514 の
 * `it-force/api/_component/device-group-for-select/.../list-device-group-for-select.api-contract.ts` を写したもの。
 * publish 後は `@standandforce/api-contract` からの import に差し替える。
 */
import { oc } from '@orpc/contract';
import { z } from 'zod';
import { pageSizeAllowingAllSchema, paginatedSchema, paginationQuerySchema } from './pagination';
const MAX_FREE_TEXT_LENGTH = 256;
export const DeviceGroupForSelectOptionSchema = z.object({
  id: z.string(),
  name: z.string()
});
const DeviceGroupForSelectListQuerySchema = paginationQuerySchema(z.enum(['name'])).extend({
  pageSize: pageSizeAllowingAllSchema(),
  freeText: z.string().max(MAX_FREE_TEXT_LENGTH).optional()
});
export const deviceGroupForSelectContract = oc.router({
  list: oc.route({
    method: 'GET',
    path: '/v2/components/device-groups-for-select'
  }).input(DeviceGroupForSelectListQuerySchema).output(paginatedSchema(DeviceGroupForSelectOptionSchema))
});
export type DeviceGroupForSelectOption = z.infer<typeof DeviceGroupForSelectOptionSchema>;